import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface PaginationState<T> {
  data: T[];
  page: number;
  limit: number;
  loading: boolean;
  finished: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class InfiniteScrollDataService<T> {
  private state: PaginationState<T> = {
    data: [],
    page: 1,
    limit: 10,
    loading: false,
    finished: false,
  };

  private dataSubject = new BehaviorSubject<PaginationState<T>>(this.state);

  get state$(): Observable<PaginationState<T>> {
    return this.dataSubject.asObservable();
  }

  reset() {
    this.state = {
      ...this.state,
      data: [],
      page: 1,
      loading: false,
      finished: false,
    };
    this.dataSubject.next(this.state);
  }

  setLoading(loading: boolean) {
    // eslint-disable-next-line object-property-newline
    this.state = { ...this.state, loading };
    this.dataSubject.next(this.state);
  }

  appendData(newData: T[]) {
    const finished = newData.length < this.state.limit;
    this.state = {
      ...this.state,
      data: [...this.state.data, ...newData],
      page: this.state.page + 1,
      loading: false,
      finished,
    };
    this.dataSubject.next(this.state);
  }

  appendDataExternal(newData: T[], isFinished: boolean) {
    this.state = {
      ...this.state,
      data: [...this.state.data, ...newData],
      page: this.state.page + 1,
      loading: false,
      finished: isFinished,
    };
    this.dataSubject.next(this.state);
  }

  getStateSnapshot(): PaginationState<T> {
    return this.state;
  }
}
